import { Content, Header, Page } from '@backstage/core-components';
import { decryptAllFilesList, fetchData, getPrivateKeyByEmail, urls } from '@internal/backstage-plugin-dh-dock-shared-common';
import { Card } from '@material-ui/core';
import LinearProgress from '@material-ui/core/LinearProgress';
import { FC, useEffect, useState } from 'react';
import React from 'react';
import GuidelinesPage from './Guidelines';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';


const GuideLines:FC<{from?:string}> = ({from}) => {

  const [guideLineList, setGuideLinesList] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const {email}=useSelector((state:RootState)=>state.auth)
  
  useEffect(() => {
    const getGuideLinesById = async () => {
      const privateKey=await getPrivateKeyByEmail(email)
      try {
        const getLocationData = await fetchData(
          `${urls.getConfigByName}guidelinesLocation`,
        );
        
        const response = await fetchData(
         `${urls.getAdrList}${getLocationData}`,
        );
        const decryptedFiles=await decryptAllFilesList(response?.data,privateKey as CryptoKey)
        const guidelineFile=decryptedFiles?.find((x:{path:string})=>x.path?.toLowerCase()==='guidelines.json');
        const getContentt=await fetchData(`${urls.getAdrContentByName}${getLocationData.concat('/'.concat(guidelineFile?.path as string))}`)
        
        setGuideLinesList(JSON.parse(getContentt?.data) as Array<string>);
        setIsLoading(false);
      } catch (error) {
        setGuideLinesList([]);
        setIsLoading(false);
      }
    };
    getGuideLinesById();
  }, []);


  return <div><Card data-testid="entity-group-list">
      {from ? <Page themeId="tool">
          <Header title="Guidelines" subtitle="A list of all the guidelines" />
          {isLoading && <LinearProgress/>}
          <Content>
            <GuidelinesPage guideLineList={guideLineList}/>
          </Content>

      </Page>:<GuidelinesPage guideLineList={guideLineList}/> }
     
    </Card></div>
  

};

export default GuideLines;
